export type AddToCartPayload = {
  id: string;
  name: string;
  price?: number;
  slug?: string;
};

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
  }
}

function ensureDataLayer(): unknown[] {
  if (typeof window === "undefined") return [];
  window.dataLayer = window.dataLayer ?? [];
  return window.dataLayer;
}

export function pushDataLayer(payload: Record<string, unknown>) {
  ensureDataLayer().push(payload);
}

export function trackPageView(path: string) {
  if (typeof window === "undefined") return;
  const page_location = window.location.origin + path;
  const page_title = document.title;
  pushDataLayer({
    event: "page_view",
    page_path: path,
    page_title,
    page_location,
  });
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: path, page_title, page_location });
  }
}

/** GA4 / GTM e-ticaret iskeleti — GTM'de add_to_cart trigger'ına bağlanır. */
export function trackAddToCart(packageData: AddToCartPayload) {
  const item = {
    item_id: packageData.id,
    item_name: packageData.name,
    item_category: "JSPS Paket",
    ...(packageData.slug ? { item_variant: packageData.slug } : {}),
    ...(typeof packageData.price === "number" ? { price: packageData.price } : {}),
    quantity: 1,
  };
  pushDataLayer({
    event: "add_to_cart",
    ecommerce: {
      currency: "TRY",
      ...(typeof packageData.price === "number" ? { value: packageData.price } : {}),
      items: [item],
    },
  });
  if (typeof window.gtag === "function") {
    window.gtag("event", "add_to_cart", {
      currency: "TRY",
      value: packageData.price,
      items: [item],
    });
  }
  if (typeof window.fbq === "function") {
    window.fbq("track", "AddToCart", {
      content_name: packageData.name,
      content_ids: [packageData.id],
      content_type: "product",
      value: packageData.price,
      currency: "TRY",
    });
  }
}
